<template>
    <div class="row">
        <div class="col-md-6 mb-2">
            <div class="form-group">
                <label class="akkurate-dark small" for="signatory_name">Name <star></star></label>
                <b-form-group id="signatory_name" label-for="signatory_name" class="akkurate-dark">
                    <b-form-input v-model="signatory.name" id="signatory_name" class="mt-1 field-container fields"
                        type="text" placeholder="Enter Name" required>
                    </b-form-input>
                </b-form-group>
                <errors v-if="signatory_errors.name">
                    {{ signatory_errors.name[0] }}
                </errors>
            </div>
        </div>


        <div class="col-md-6 mb-2">
            <div class="form-group">
                <label class="akkurate-dark small" for="signatory_position">Position <star></star>
                </label>
                <b-form-group id="signatory_position" label-for="signatory_position" class="akkurate-dark">
                    <b-form-input v-model="signatory.position" id="signatory_position"
                        class="mt-1 field-container fields" type="text" placeholder="Enter Position" required>
                    </b-form-input>
                </b-form-group>
                <errors v-if="signatory_errors.position">
                    {{ signatory_errors.position[0] }}
                </errors>
            </div>

        </div>

        <div class="col-md-6 mb-2">
            <div class="form-group">
                <label class="akkurate-dark small" for="signatory_id_type">ID Type <star></star>
                </label>
                <multiselect class="mt-1 field-container" v-model="signatory.id_type"
                    :options="card_option">
                </multiselect>
                <errors v-if="signatory_errors.id_type">
                    {{ signatory_errors.id_type[0] }}
                </errors>
            </div>
        </div>

        <div class="col-md-6 mb-2">
            <div class="form-group">
                <label class="akkurate-dark small" for="signatory_id_type">Signatory Type <star></star></label>
                <multiselect class="mt-1 field-container" v-model="signatory.signatory_type"
                    :options="signatories_option">
                </multiselect>
                <errors v-if="signatory_errors.signatory_type">
                    {{ signatory_errors.signatory_type[0] }}
                </errors>
            </div>
        </div>


        <div class="col-md-6 mb-2">
            <div class="form-group">
                <label class="akkurate-dark small" for="signatory_id_number">ID Number <star></star></label>
                <b-form-group id="signatory_id_number" label-for="signatory_id_number" class="akkurate-dark">
                    <b-form-input v-model="signatory.id_number" id="signatory_id_number"
                        class="mt-1 field-container fields" type="text" placeholder="Enter ID Number" required>
                    </b-form-input>
                </b-form-group>
                <errors v-if="signatory_errors.id_number">
                    {{ signatory_errors.id_number[0] }}
                </errors>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import vueDropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
export default {
    props: ['signatory'],
    components: {
        vueDropzone,
        Multiselect
    },

    data() {
        return {
            signatory_errors: "",
            card_option: ['Ghana Card','Passport','Voters ID'],
            signatories_option: ['PRINCIPAL', 'OTHERS'],
        }
    },
    methods: {
        // removeFile() {
        //     const dropzone = this.$refs.myVueDropzone;
        //     const files = dropzone.dropzone.files; // Get the list of files

        //     if (files.length > 0) {
        //         const fileToRemove = files[files.length - 1]; // For example, remove the last file
        //         dropzone.removeFile(fileToRemove); // Call removeFile on the dropzone instance
        //     }
        // },
        // handleSignatorySubmit() {
        //     if (this.signatory.name && this.signatory.position) {
        //         this.form.signatories.push({ ...this.signatory });
        //         this.signatory = {
        //             name: "",
        //             position: "",
        //             id_type: "",
        //             id_number: ""
        //         };
        //         this.$bvModal.hide('add-signatory-modal');
        //     }
        // // },
        // handleSignatorySubmit() {
        //     // Validate required fields
        //     if (!this.signatory.name || !this.signatory.position ||
        //         !this.signatory.id_type || !this.signatory.id_number ||
        //         !this.signatory.signatory_type) {
        //         this.signatory_errors = {
        //             name: !this.signatory.name ? ['Name is required'] : null,
        //             position: !this.signatory.position ? ['Position is required'] : null,
        //             id_type: !this.signatory.id_type ? ['ID Type is required'] : null,
        //             id_number: !this.signatory.id_number ? ['ID Number is required'] : null,
        //             signatory_type: !this.signatory.signatory_type ? ['Signatory Type is required'] : null
        //         };
        //         return;
        //     }

        //     // Create FormData for file uploads
        //     const formData = new FormData();
        //     if (this.profile_file) formData.append('profile_photo', this.profile_file);
        //     if (this.ghana_card_front_file) formData.append('ghana_card_front', this.ghana_card_front_file);
        //     if (this.ghana_card_back_file) formData.append('ghana_card_back', this.ghana_card_back_file);
        //     if (this.signature_file) formData.append('signature', this.signature_file);

        //     // Upload files first
        //     Promise.all([
        //         this.profile_file ? this.uploadFile(formData, 'profile_photo') : Promise.resolve(null),
        //         this.ghana_card_front_file ? this.uploadFile(formData, 'ghana_card_front') : Promise.resolve(null),
        //         this.ghana_card_back_file ? this.uploadFile(formData, 'ghana_card_back') : Promise.resolve(null),
        //         this.signature_file ? this.uploadFile(formData, 'signature') : Promise.resolve(null)
        //     ]).then(([profilePath, frontPath, backPath, signaturePath]) => {
        //         // Create signatory object with file paths
        //         const signatory = {
        //             ...this.signatory,
        //             profile_photo: profilePath,
        //             ghana_card_front: frontPath,
        //             ghana_card_back: backPath,
        //             signature: signaturePath
        //         };

        //         // Add to form.signatories array
        //         this.form.signatories.push(signatory);

        //         // Reset form and close modal
        //         this.resetForm();
        //         this.$bvModal.hide('add-signatory-modal');
        //     }).catch(error => {
        //         console.error('Error uploading files:', error);
        //         this.signatory_errors = {
        //             general: ['Error uploading files. Please try again.']
        //         };
        //     });
        // },

        // uploadFile(formData, fileType) {
        //     return ApiService.post('/images/store', formData)
        //         .then(response => response.data.path)
        //         .catch(error => {
        //             throw new Error(`Error uploading ${fileType}: ${error.message}`);
        //         });
        // },

        // resetForm() {
        //     this.signatory = {
        //         name: "",
        //         position: "",
        //         id_type: "",
        //         id_number: "",
        //         signatory_type: ""
        //     };
        //     this.signatory_errors = {};
        //     this.profile_file = null;
        //     this.ghana_card_front_file = null;
        //     this.ghana_card_back_file = null;
        //     this.signature_file = null;

        //     // Reset dropzone files
        //     ['profileDropzone', 'ghanaCardFrontDropzone', 'ghanaCardBackDropzone', 'signatureDropzone'].forEach(ref => {
        //         if (this.$refs[ref] && this.$refs[ref].dropzone) {
        //             this.$refs[ref].dropzone.removeAllFiles();
        //         }
        //     });
        // },
        // onSignatoryProfilePhotoAdded(files) {
        //     this.profile_file = files[0];
        // },

        // onGhanaCardFrontAdded(files) {
        //     this.ghana_card_front_file = files[0];
        // },

        // onGhanaCardBackAdded(files) {
        //     this.ghana_card_back_file = files[0];
        // },

        // onSignatureAdded(files) {
        //     this.signature_file = files[0];
        // },

    }
}
</script>